import axios from '../axios';
import * as models from '../models';
import * as hyejoo from './hyejoo';
import { Format } from '../phone';
import { GetPageRequestID } from './pagerequests';
import { UserDetails } from './users';

export async function GetShippingOptions(params?: Record<string, string>): Promise<hyejoo.ShippingOption[]> {
    return axios.get<hyejoo.ShippingOptions>('/shipping-options', { params }).then(resp => resp.data.shippingOptions);
}

export async function NewShippingOption(user: UserDetails, shippingOption: models.ShippingOption): Promise<models.ShippingOption> {
    user.phone = Format(user.phone);
    user.tz ??= Intl.DateTimeFormat().resolvedOptions().timeZone;
    user.pageRequestID ??= await GetPageRequestID();
    if (!shippingOption.country && shippingOption.countryID) {
        shippingOption.country = { id: shippingOption.countryID };
    }
    if (!shippingOption.state && shippingOption.stateID) {
        shippingOption.state = { id: shippingOption.stateID };
    }

    return axios.post<models.ShippingOption>('/shipping-options', {
        'user': user,
        'fullName': shippingOption.fullName,
        'company': shippingOption.company,
        'addressLine1': shippingOption.addressLine1,
        'addressLine2': shippingOption.addressLine2,
        'city': shippingOption.city,
        'state': shippingOption.state ? {
            'id': shippingOption.state.id,
        } : undefined,
        'zip': shippingOption.zip,
        'country': {
            'id': shippingOption.country?.id,
        },
        'phone': shippingOption.phone,
        'email': shippingOption.email,
    }).then(resp => resp.data);
}

export function DeleteShippingOption(shippingOptionID: string) {
    return axios.delete(`/shipping-options/${shippingOptionID}`);
}

export function RestoreShippingOption(shippingOptionID: string) {
    return axios.patch(`/shipping-options/${shippingOptionID}`, { 'active': true });
}